/**
 * Theme switch (D-091, D-103, D-105). Not a kid-facing control.
 *
 *   (no param)        whatever the device remembered, else the default direction
 *   ?theme=<name>     applies a direction or palette and remembers it
 *   ?theme=classic    the dark placeholder shell the design pass started from
 *                     (no data-theme attribute), remembered like any other
 *   ?theme=default    forgets the memory and applies the default direction
 *
 * The default direction is Sticker Book in the Safari palette (D-105). Each file
 * in styles/themes/ scopes its tokens under `:root[data-theme="…"]`, so with no
 * attribute the app is exactly the shell it was before themes existed.
 */
const KEY = 'ab.theme.v1'
export const THEMES = ['field-guide', 'arena', 'sticker-book', 'sticker-book-safari', 'sticker-book-meadow']
export const DEFAULT_THEME = 'sticker-book-safari'
export const CLASSIC = 'classic'

const known = (name) => THEMES.includes(name) || name === CLASSIC

export function applyTheme() {
  let requested = null
  try {
    requested = new URLSearchParams(window.location.search).get('theme')
  } catch {
    requested = null
  }

  let name
  if (requested !== null) {
    // An explicit param always wins; "default" (or anything unknown) forgets the
    // remembered choice and returns to the default direction.
    name = known(requested) ? requested : DEFAULT_THEME
    try {
      if (known(requested)) localStorage.setItem(KEY, name)
      else localStorage.removeItem(KEY)
    } catch {
      /* storage blocked: the param still applies for this load */
    }
  } else {
    let saved = null
    try {
      saved = localStorage.getItem(KEY)
    } catch {
      saved = null
    }
    name = known(saved) ? saved : DEFAULT_THEME
  }

  if (name === CLASSIC) delete document.documentElement.dataset.theme
  else document.documentElement.dataset.theme = name
  return name === CLASSIC ? null : name
}
